import NotFound from "@views/NotFound.vue";
import NotAuthorized from "@views/NotAuthorized.vue";

import AuthLayout from "@views/layouts/AuthLayout.vue";
import MasterLayout from "@views/layouts/MasterLayout.vue";

import AuthRoutes from "./routes/auth-routes";
import AdminRoutes from "./routes/admin-routes";
import DashboardRoutes from "./routes/dashboard-routes";

export default [
    {
        path: "/auth",
        name: "auth",
        redirect: {name: "login"},
        component: AuthLayout,
        children: AuthRoutes,
    },
    {
        path: '/',
        redirect: '/home',
        component: MasterLayout,
        meta: {
            requiresAuth: true
        },
        children: DashboardRoutes,
    },
    {
        path: "/admin",
        redirect: {name: "admin"},
        component: MasterLayout,
        meta: {
            requiresAuth: true,
        },
        children: AdminRoutes,
    }, {
        path: "/401",
        name: "401",
        component: NotAuthorized,
        meta: {
            title: "Not Authorized",
        },
    },
    {
        path: "/:pathMatch(.*)*",
        name: "not-found",
        component: NotFound,
    },
];
